import { SENSOR_CHANNELS } from '../../../services/sensorRegistry.generated';

/**
 * The channels a rule can name, as the editor offers them.
 *
 * Deduplicated by groupKey, because that is the identity the rule language uses:
 * SP_PM25 and AE_PM2.5 are one measurement and must appear once, or the user
 * picks "PM2.5 Particulates" twice and cannot tell the entries apart.
 */
export const channelOptions = () => {
  const byGroupKey = new Map();
  SENSOR_CHANNELS.forEach((c) => {
    if (!byGroupKey.has(c.groupKey)) {
      byGroupKey.set(c.groupKey, {
        groupKey: c.groupKey,
        label: c.shortName,
        longLabel: c.longName,
        unit: c.unit,
        group: c.group,
      });
    }
  });
  return [...byGroupKey.values()].sort(
    (a, b) => a.group.localeCompare(b.group) || a.label.localeCompare(b.label)
  );
};

export const channelLabel = (groupKey) =>
  channelOptions().find((c) => c.groupKey === groupKey)?.label ?? groupKey;

export const channelUnit = (groupKey) =>
  channelOptions().find((c) => c.groupKey === groupKey)?.unit ?? null;
